export default {
    INIT_FORM: "INIT_FORM",
    RESET_FORM: "RESET_FORM",
    SET_FORM_ERRORS: "SET_FORM_ERRORS",
    REMOVE_FORM_ERROR: "REMOVE_FORM_ERROR",
    RESET_FORM_ERRORS: "RESET_FORM_ERRORS",
};
